import { useQuery } from "@tanstack/react-query";
import { listBooks } from "./api";

export function useBooks() {
  return useQuery({ queryKey: ["books"], queryFn: () => listBooks(true), staleTime: 30_000 });
}
